import React from 'react';
import dayjs from 'dayjs';
import { block } from 'bem-cn';

import './pion-content-youtube.scss';
import { PionType, ImmutableMapItem } from '../../../type';

const millisecondsInSecond = 1000;
const b = block('pion-content-youtube');

type PionYoutubeContentPropsType = {
  pion: Pick<
    PionType,
    | keyof ImmutableMapItem
    | 'id'
    | 'type'
    | 'embedUrl'
    | 'thumbnailUrl'
    | 'urlTitle'
    | 'uploadedBy'
    | 'duration'
  >;
};

const PionYoutubeContent = ({ pion }: PionYoutubeContentPropsType) => (
  <div className={b()}>
    <div className={b('preview')}>
      <img
        data-testid='pion-youtube-image'
        src={pion.get('thumbnailUrl')}
        alt={pion.get('urlTitle')}
      />
    </div>
    <div className={b('info')}>
      <div>
        <h2 data-testid='title' className={b('title')}>
          {pion.get('urlTitle')}
        </h2>
        <div data-testid='uploaded-by' className={b('text')}>
          {pion.get('uploadedBy')}
        </div>
      </div>
      <div data-testid='duration' className={b('text')}>
        {dayjs(pion.get('duration') * millisecondsInSecond).format('mm:ss')}
      </div>
    </div>
  </div>
);

export default PionYoutubeContent;
